import React from "react";
import Page from "../../page-layout";
import MaxWidthContainer from "../../../components/UI/MaxWidthContainer/MaxWidthContainer";
import { BackButton } from "@core/components";

const FormalitiesPage = () => {
  return (
    <Page>
      <Page.Header>
        <MaxWidthContainer>
          <div className="flex items-center gap-2">
            <BackButton />
            <div className="text-2xl font-bold">Формальности</div>
          </div>
        </MaxWidthContainer>
      </Page.Header>
      <Page.Content>
        <div>Формальности</div>
      </Page.Content>
    </Page>
  );
};

export default FormalitiesPage;
